var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "product-review w-[calc(100%-2rem)] mx-auto" },
    [
      _c("div", { staticClass: "bg-white rounded-lg p-3 mb-2" }, [
        _c("div", { staticClass: "flex items-start space-x-4" }, [
          _c("img", {
            staticClass: "w-20 h-20 rounded-lg flex-shrink-0",
            attrs: { src: _vm.imageBaseUrl + _vm.detailInfo.picUrl },
          }),
          _c("div", { staticClass: "flex-1" }, [
            _c("div", { staticClass: "flex items-center justify-between" }, [
              _c("h3", { staticClass: "text-base font-medium mb-2" }, [
                _vm._v(
                  _vm._s(_vm.detailInfo.type) +
                    " - " +
                    _vm._s(
                      _vm.isZh ? _vm.detailInfo.place : _vm.detailInfo.placeEn
                    )
                ),
              ]),
              _c("span", { staticClass: "text-xs text-gray-500" }, [
                _vm._v(
                  _vm._s(_vm.detailInfo.favoriteCount) +
                    _vm._s(_vm.$t("home.favoriteCount"))
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "flex items-center mb-2" },
              [
                _c("van-rate", {
                  attrs: {
                    readonly: "",
                    size: "14",
                    color: "#ffd21e",
                    "void-color": "#eee",
                  },
                  model: {
                    value: _vm.detailInfo.score,
                    callback: function ($$v) {
                      _vm.$set(_vm.detailInfo, "score", $$v)
                    },
                    expression: "detailInfo.score",
                  },
                }),
                _c("span", { staticClass: "ml-2 text-sm font-medium" }, [
                  _vm._v(_vm._s(_vm.detailInfo.score)),
                ]),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "flex items-center justify-between text-sm text-gray-500",
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.detailInfo.commentCount) +
                      " " +
                      _vm._s(_vm.$t("products.reviewCount"))
                  ),
                ]),
                _c(
                  "span",
                  {
                    staticClass: "text-[#ff7a00]",
                    on: { click: _vm.showAllReviews },
                  },
                  [_vm._v(_vm._s(_vm.$t("products.showAll")) + " >")]
                ),
              ]
            ),
          ]),
        ]),
        _c("div", { staticClass: "mt-4" }, [
          _c(
            "div",
            { staticClass: "flex flex-wrap" },
            _vm._l(
              _vm.isZh
                ? _vm.detailInfo.commentTags
                : _vm.detailInfo.commentTagsEn,
              function (feature) {
                return _c(
                  "div",
                  { key: feature, staticClass: "flex items-center mr-6 mb-2" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center mr-2",
                      },
                      [
                        _c("van-icon", {
                          attrs: {
                            name: "success",
                            size: "12",
                            color: "white",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("span", { staticClass: "text-xs text-gray-600" }, [
                      _vm._v(_vm._s(feature)),
                    ]),
                  ]
                )
              }
            ),
            0
          ),
        ]),
      ]),
      _c("div", { staticClass: "bg-white rounded-lg py-3 px-4" }, [
        _vm.reviews.length > 0
          ? _c(
              "div",
              [
                _vm._l(_vm.reviews, function (review) {
                  return _c(
                    "div",
                    { key: review.id, staticClass: "last:mb-0" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex items-center mb-2" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "w-6 h-6 rounded-full mr-2 text-xs bg-orange-300 text-white leading-6 text-center align-middle",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.firstLetter(review.userNickname)) +
                                  " "
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "text-sm font-medium" }, [
                            _vm._v(_vm._s(review.userNickname)),
                          ]),
                          _c("van-rate", {
                            staticClass: "ml-2",
                            attrs: {
                              readonly: "",
                              size: "12",
                              color: "#ffd21e",
                              "void-color": "#eee",
                            },
                            model: {
                              value: review.scores,
                              callback: function ($$v) {
                                _vm.$set(review, "scores", $$v)
                              },
                              expression: "review.scores",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-sm text-gray-700 mb-2 leading-relaxed",
                        },
                        [
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-sm text-gray-700 mb-1 leading-relaxed",
                              },
                              [_vm._v(_vm._s(review.content))]
                            ),
                            _c(
                              "div",
                              { staticClass: "text-xs text-gray-400" },
                              [
                                _vm._v(
                                  _vm._s(_vm.formatDate(review.createTime))
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      review.id !== _vm.reviews[_vm.reviews.length - 1].id
                        ? _c("van-divider")
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                _c(
                  "div",
                  {
                    staticClass: "text-[#ff7a00] text-center",
                    on: { click: _vm.showAllReviews },
                  },
                  [_vm._v(_vm._s(_vm.$t("products.showAll")) + " >>")]
                ),
              ],
              2
            )
          : _vm._e(),
        !_vm.reviews.length && !_vm.loading
          ? _c("div", { staticClass: "text-center text-gray-500 py-4" }, [
              _vm._v(" " + _vm._s(_vm.$t("common.noData")) + " "),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }